import { AfterViewInit, Component, ElementRef, Input, OnInit, signal, ViewChild } from '@angular/core';
import { NgIf } from '@angular/common';
import * as L from 'leaflet';
import { Address, NominatimService } from 'src/app/services/nominatim.service';
import { catchError, from, mergeMap, Observable, of, toArray, map, merge, filter, finalize, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-leaflet-map',
  standalone: true,
  imports: [NgIf],
  templateUrl: './leaflet-map.component.html',
  styleUrls: ['./leaflet-map.component.scss']
})
export class LeafletMapComponent implements AfterViewInit {
  @Input() company!: any;

  markersLoading$ = signal<boolean>(true);
  
  
  private map!: L.Map;
  markers: L.Marker[] = [];
  tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    minZoom: 3,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  });
  @ViewChild('mapLeaflet') mapLeaflet!: ElementRef;

  constructor(private nominatimService: NominatimService) { }

  ngAfterViewInit() {
    this.initMap();
    this.initCompanyMarkers()
    // this.addMarkers();
  }

  // ngOnInit() {
  //   // this.initMap();
  // }
  
  initMap() {
    const zoomDefault = 5;
    const wheelZoom = false;

    if (this.mapLeaflet != null) {
      this.map = L.map('mapLeaflet', { scrollWheelZoom: wheelZoom }).setView([41.4182315, 12.8811031], zoomDefault);
      this.tiles.addTo(this.map);
    }
  }

  initCompanyMarkers() {
    if(this.company?.additionalInformation?.localBranches.length && this.company?.additionalInformation?.localBranches[0]?.hasOwnProperty('nominatim')) {
      const nominatims = this.company.additionalInformation.localBranches.flatMap((branch: any) => branch.nominatim);
      const markers = nominatims.map((nominatim: any) => L.marker([nominatim.lat, nominatim.lon], {
        icon: L.icon({
          iconSize: [25, 41],
          iconAnchor: [13, 41],
          iconUrl: environment.assetsPrefixUrl + 'assets/marker-icon.png',
          shadowUrl:environment.assetsPrefixUrl + 'assets/marker-shadow.png'
        })
      }).addTo(this.map).bindPopup(this.makeCapitalPopup(
        this.company?.additionalInformation?.localBranches.find((branch: any) => branch?.nominatim.toString() === nominatim.toString())?.address,
        this.company?.additionalInformation?.localBranches.find((branch: any) => branch?.nominatim.toString() === nominatim.toString())?.branchNumber)));
      // this.markers.push(...markers);
      this.markersLoading$.set(false);
    } else {
      this.addMarkers();
    }
  }
  private addMarkers() {

    this.nominatimService.getNominatim().then((sub: Observable<any>) => {
      sub.pipe(
        catchError((err: any) => {
          console.log(err);
          this.markersLoading$.set(false);
          return of(null);
        }),
        mergeMap((data: any) => { return from(data.payload) }),
        filter((data: any) => data?.address?.nominatim?.length),
        tap((data: any) => {
          data.address.nominatim.forEach((sede: any) => {
               const marker = L.marker([sede.lat, sede.lon], {
              icon: L.icon({
                iconSize: [25, 41],
                iconAnchor: [13, 41],
                className: 'marker-fall',
                iconUrl: environment.assetsPrefixUrl + '/images/icons/marker-icon.png',
                shadowUrl:environment.assetsPrefixUrl + '/images/icons/marker-shadow.png'
              })
            }).addTo(this.map).bindPopup(this.makeCapitalPopup(data.address, data.branchNumber));
          //  this.markers.push(marker);
            })
        }),
        finalize(() => {
          this.markersLoading$.set(false);
        })
      ).subscribe();
      }).catch((err: any) => {
        console.log(err);
        this.markersLoading$.set(false);
      })
  }

  lookupAddress(addressString: string) {
    

  }

  makeCapitalPopup(address?: any, idx?: string): string {
    if (!address) {
      return ``;
    }
    return `` +
      `<div><strong>Sede n°</strong>:  <small>${idx?? '--'} </small></div>` +
      `<div><strong>Location</strong>: <small>${address?.city} (${address?.province}) </small></div>`;
  }

}
